( function( $ ) {

    $(document).ready(function() {
        AOS.init();
    })

    /*input phone*/
    $('input[type="text"].js-phnInp').on('input', function() {
        this.value = this.value.replace(/[^0-9\+]/g, '');
    });
    /*input phone*/
 
    /*desktop/mob link change*/
    $(window).on('load resize', function(){
        $('[href^="tel:"]').each(function(){
            var $this = $(this);
            var tag = '';
            if ($(window).width() > 991) {
                // e.preventDefault();
                tag = '<span>';
            } else {
                tag = '<a>';
            }
            var $span = $(tag).html($this.html());
            $.each(this.attributes, function() {
                $span.attr(this.name, this.value);
            });
            $this.replaceWith($span);
        });
    });
    /*desktop/mob link change*/

    /*header*/
    $(window).scroll(function(){
        var hHeight = $('.js-header').outerHeight();
        if ($(window).scrollTop() > hHeight) {
            $('.js-header').addClass('fixed');
        } else {
            $('.js-header').removeClass('fixed');
        }
    });
    /*header*/

    /*header menu*/
    $('.js-hMenuBtn').click(function(){
        $(this).toggleClass('active');
        $(this).attr('aria-expanded', $(this).hasClass('active') ? 'true' : 'false');
        $('.js-hMenu').slideToggle();
    });


    $('.js-hMenu').click(function(e) {
        e.stopPropagation();
    });
    $('.js-hMenu ul li a, .js-hRdvBtn').click(function(e) {
        if ($(window).width() < 992) {
            $('.js-hMenuBtn').removeClass('active').attr('aria-expanded', 'false');
            $('.js-hMenu').slideUp();
        }
    });

    $('.js-hMenuArr').click(function(e) {
        $(this).toggleClass('clicked');
        $(this).siblings('.sub-menu').slideToggle()
    });
    /*header menu*/

    /*modal contact*/
    $('.js-modlBtn, a[href="#modal"]').click(function(e){
        e.preventDefault();
        $('.js-modalWindow').addClass('active');
        $('body').css('overflow', 'hidden');
    })
    $('.js-modalWindowCls').click(function(){
        $('.js-modalWindow').removeClass('active');
        $('body').css('overflow', '');
    });
    /*modal contact*/


    /*widget_cirle*/
    window.addEventListener('scroll', function() {
        const rotatingElement = document.querySelector('.js-circleWidgetText');
        const rotationAmount = window.scrollY / 5;

        rotatingElement.style.transform = `rotate(${rotationAmount}deg)`;
    });
    /*widget_cirle*/

    /*video*/
    $(document).ready(function () {
        const player = $('#vimeo-player')[0];
        $('.js-firstLoud').on('click', function () {
            const $this = $(this);
            player.muted = !player.muted;
            $this.find('.sound').removeClass('active');
            if (player.muted) {
                $this.find('.sound[data-sound="disabled"]').addClass('active');
            } else {
                $this.find('.sound[data-sound="enabled"]').addClass('active');
            }
        });
        $('.js-firstLoud').on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                $(this).trigger('click');
            }
        });
    });
    /*video*/

    /*main-line*/
    $(document).ready(function() {
        $('.js-mainLine').marquee({
            duration: ($(window).width() > 991) ? 25000 : 40000,
            gap: 0,
            delayBeforeStart: 0,
            direction: 'left',
            startVisible: true,
            duplicated: true,
            duplicateCount: 2
        });
    });
    /*main-line*/

    /*main-equipe*/

    const wrap = document.querySelector('.js-mainEquipeCards');
    if (wrap !== null) {
    const cards = Array.from(wrap.querySelectorAll('.js-mainEquipeCard'));
    const first = cards[0];

        cards.forEach(card => {
            card.addEventListener('mouseenter', () => {
                cards.forEach(c => c.classList.remove('is-active'));
                card.classList.add('is-active');
            });
        });

        // when the cursor leaves the whole group, the first card becomes active again
        wrap.addEventListener('mouseleave', () => {
            cards.forEach(c => c.classList.remove('is-active'));
            first.classList.add('is-active');
        });
    }
    /*main-equipe*/

    /*main-vals*/
    $('.js-mainValsListBl').mouseover(function (){
        var img = $(this).data('img');
        $('.js-mainValsListBl').removeClass('active');
        $(this).addClass('active');

        $('.js-mainValsListLogo').addClass('active');

        $('.js-mainValsListImg').removeClass('active');
        $('.js-mainValsListImg[data-img="'+img+'"]').addClass('active');
    })
    $('.js-mainValsListBl').mouseleave(function (){
        $('.js-mainValsListBl').removeClass('active');

        $('.js-mainValsListLogo').removeClass('active');

        $('.js-mainValsListImg').removeClass('active');
    })
    /*main-vals*/

    /*main-traits*/
    document.querySelectorAll('.js-mainTraitsCol').forEach(function (col) {
        col.addEventListener('mouseenter', function () {
            if (window.innerWidth > 991) {
                document.querySelectorAll('.js-mainTraitsCol').forEach(function (c) { c.classList.remove('active'); });
                col.classList.add('active');
            }
        });
    });
    /*main-traits*/

    /*main-techs*/
    document.querySelectorAll('.js-mainTechsBl').forEach(function (bl) {
        bl.addEventListener('click', function (e) {
            if (window.innerWidth < 768 && !bl.classList.contains('active')) {
                e.preventDefault();
                document.querySelectorAll('.js-mainTechsBl').forEach(function (b) { b.classList.remove('active'); });
                bl.classList.add('active');
            }
        });
    });
    /*main-techs*/

    /*rellax*/
    if ($('.js-parallax').length > 0) {
        const rellax = new Rellax('.js-parallax', {
            speed: -2,
            center: true
        });
    }
    /*rellax*/

    /*slider*/
    $('.js-sliderSlider').on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
        var cnt = slick.options.slidesToScroll;
        var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
        $(this).closest('.js-sliderSliderWrap').find('.js-sliderSliderCounter').html(
            '<span>' + slideNum + '</span><span class="sep"> — </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
        );
    });

    $('.js-slider').slick({
        arrows: true,
        centerMode: false,
        slidesToShow: 1,
        adaptiveHeight: true,
        prevArrow: '<button type="button" class="arrow prev-arrow" aria-label="Précédent"><svg aria-hidden="true" focusable="false" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.5 7.03535H15V8.03535H14.5V7.53535V7.03535ZM0.5 8.03535C0.223858 8.03535 0 7.8115 0 7.53535C0 7.25921 0.223858 7.03535 0.5 7.03535V7.53535V8.03535ZM7.03474 0.5V0L8.03474 0V0.5L7.53474 0.5L7.03474 0.5ZM0.810138 7.90359C0.567717 8.03583 0.263996 7.9465 0.131761 7.70408C-0.000475883 7.46166 0.0888472 7.15794 0.331269 7.0257L0.570704 7.46465L0.810138 7.90359ZM8.0348 14.5V15H7.0348V14.5H7.5348H8.0348ZM14.5 7.53535V8.03535L0.570761 8.03535V7.53535V7.03535L14.5 7.03535V7.53535ZM0.570761 7.53535V8.03535H0.5V7.53535V7.03535H0.570761V7.53535ZM7.53474 0.5L8.03474 0.5C8.03474 1.46517 7.51122 2.40874 6.83424 3.23966C6.14729 4.08282 5.24358 4.88117 4.35846 5.56517C3.4704 6.25145 2.58482 6.83499 1.92269 7.24634C1.59115 7.45231 1.31451 7.6158 1.12013 7.72814C1.02292 7.78432 0.946214 7.82775 0.893425 7.85735C0.867028 7.87215 0.846606 7.88349 0.832584 7.89124C0.825573 7.89512 0.820162 7.89809 0.816403 7.90016C0.814524 7.90119 0.813058 7.90199 0.812011 7.90257C0.811488 7.90285 0.811069 7.90308 0.810758 7.90325C0.810601 7.90334 0.810446 7.90342 0.810368 7.90346C0.81024 7.90353 0.810138 7.90359 0.570704 7.46465C0.331269 7.0257 0.331221 7.02573 0.331199 7.02574C0.331226 7.02573 0.33123 7.02572 0.331285 7.02569C0.331397 7.02563 0.331613 7.02552 0.331933 7.02534C0.332573 7.02499 0.333631 7.02441 0.335099 7.0236C0.338035 7.02199 0.342612 7.01947 0.348778 7.01607C0.361109 7.00925 0.379791 6.99887 0.404401 6.98508C0.453625 6.95748 0.526535 6.91621 0.619744 6.86234C0.806212 6.75457 1.07364 6.59655 1.39498 6.39691C2.03861 5.99706 2.89404 5.43305 3.74698 4.77391C4.60288 4.11249 5.44017 3.36754 6.05898 2.60803C6.68775 1.83627 7.03474 1.11779 7.03474 0.5L7.53474 0.5ZM0.570761 7.53535C0.758092 7.07177 0.758235 7.07183 0.758404 7.0719C0.758495 7.07194 0.758692 7.07202 0.758875 7.07209C0.759243 7.07224 0.759716 7.07243 0.760294 7.07267C0.761451 7.07314 0.763028 7.07378 0.765019 7.07459C0.769002 7.07622 0.77464 7.07854 0.781881 7.08153C0.796362 7.08752 0.817256 7.09624 0.844136 7.10764C0.89789 7.13042 0.975623 7.16395 1.07391 7.20785C1.27042 7.29563 1.54951 7.42506 1.88372 7.59332C2.55089 7.92919 3.44389 8.42281 4.34008 9.05202C5.23369 9.67942 6.14794 10.4537 6.84276 11.3556C7.53813 12.2583 8.0348 13.3172 8.0348 14.5H7.5348H7.0348C7.0348 13.6076 6.66095 12.7582 6.05057 11.9659C5.43963 11.1729 4.61287 10.4654 3.76547 9.87045C2.92066 9.27731 2.07265 8.808 1.43406 8.48652C1.1154 8.32609 0.850417 8.20325 0.66608 8.12091C0.573947 8.07976 0.502062 8.04877 0.453804 8.02831C0.429679 8.01808 0.411468 8.01049 0.399595 8.00558C0.39366 8.00312 0.389309 8.00134 0.386597 8.00023C0.385241 7.99967 0.384295 7.99929 0.383764 7.99907C0.383499 7.99896 0.383338 7.9989 0.383282 7.99888C0.383254 7.99886 0.383291 7.99888 0.383277 7.99887C0.38334 7.9989 0.38343 7.99894 0.570761 7.53535Z" fill="white"/> </svg></button>',
        nextArrow: '<button type="button" class="arrow next-arrow" aria-label="Suivant"><svg aria-hidden="true" focusable="false" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 7.03535H0L0 8.03535H0.5L0.5 7.53535L0.5 7.03535ZM14.5 8.03535C14.7761 8.03535 15 7.8115 15 7.53535C15 7.25921 14.7761 7.03535 14.5 7.03535V7.53535V8.03535ZM7.96526 0.5V0L6.96526 0V0.5L7.46526 0.5L7.96526 0.5ZM14.1899 7.90359C14.4323 8.03583 14.736 7.9465 14.8682 7.70408C15.0005 7.46166 14.9112 7.15794 14.6687 7.0257L14.4293 7.46465L14.1899 7.90359ZM6.9652 14.5V15H7.9652V14.5H7.4652H6.9652ZM0.5 7.53535L0.5 8.03535L14.4292 8.03535V7.53535V7.03535L0.5 7.03535L0.5 7.53535ZM14.4292 7.53535V8.03535H14.5V7.53535V7.03535H14.4292V7.53535ZM7.46526 0.5L6.96526 0.5C6.96526 1.46517 7.48878 2.40874 8.16576 3.23966C8.85271 4.08282 9.75642 4.88117 10.6415 5.56517C11.5296 6.25145 12.4152 6.83499 13.0773 7.24634C13.4088 7.45231 13.6855 7.6158 13.8799 7.72814C13.9771 7.78432 14.0538 7.82775 14.1066 7.85735C14.133 7.87215 14.1534 7.88349 14.1674 7.89124C14.1744 7.89512 14.1798 7.89809 14.1836 7.90016C14.1855 7.90119 14.1869 7.90199 14.188 7.90257C14.1885 7.90285 14.1889 7.90308 14.1892 7.90325C14.1894 7.90334 14.1896 7.90342 14.1896 7.90346C14.1898 7.90353 14.1899 7.90359 14.4293 7.46465C14.6687 7.0257 14.6688 7.02573 14.6688 7.02574C14.6688 7.02573 14.6688 7.02572 14.6687 7.02569C14.6686 7.02563 14.6684 7.02552 14.6681 7.02534C14.6674 7.02499 14.6664 7.02441 14.6649 7.0236C14.662 7.02199 14.6574 7.01947 14.6512 7.01607C14.6389 7.00925 14.6202 6.99887 14.5956 6.98508C14.5464 6.95748 14.4735 6.91621 14.3803 6.86234C14.1938 6.75457 13.9264 6.59655 13.605 6.39691C12.9614 5.99706 12.106 5.43305 11.253 4.77391C10.3971 4.11249 9.55983 3.36754 8.94102 2.60803C8.31225 1.83627 7.96526 1.11779 7.96526 0.5L7.46526 0.5ZM14.4292 7.53535C14.2419 7.07177 14.2418 7.07183 14.2416 7.0719C14.2415 7.07194 14.2413 7.07202 14.2411 7.07209C14.2408 7.07224 14.2403 7.07243 14.2397 7.07267C14.2385 7.07314 14.237 7.07378 14.235 7.07459C14.231 7.07622 14.2254 7.07854 14.2181 7.08153C14.2036 7.08752 14.1827 7.09624 14.1559 7.10764C14.1021 7.13042 14.0244 7.16395 13.9261 7.20785C13.7296 7.29563 13.4505 7.42506 13.1163 7.59332C12.4491 7.92919 11.5561 8.42281 10.6599 9.05202C9.76631 9.67942 8.85206 10.4537 8.15724 11.3556C7.46187 12.2583 6.9652 13.3172 6.9652 14.5H7.4652H7.9652C7.9652 13.6076 8.33905 12.7582 8.94943 11.9659C9.56037 11.1729 10.3871 10.4654 11.2345 9.87045C12.0793 9.27731 12.9274 8.808 13.5659 8.48652C13.8846 8.32609 14.1496 8.20325 14.3339 8.12091C14.4261 8.07976 14.4979 8.04877 14.5462 8.02831C14.5703 8.01808 14.5885 8.01049 14.6004 8.00558C14.6063 8.00312 14.6107 8.00134 14.6134 8.00023C14.6148 7.99967 14.6157 7.99929 14.6162 7.99907C14.6165 7.99896 14.6167 7.9989 14.6167 7.99888C14.6167 7.99886 14.6167 7.99888 14.6167 7.99887C14.6167 7.9989 14.6166 7.99894 14.4292 7.53535Z" fill="white"/> </svg></button>',
        appendArrows: $('.js-sliderSliderWrap').find('.js-sliderSliderArrows')
    });
    /*slider*/

    /*wpcf7 thankyou*/
    document.addEventListener('wpcf7mailsent', function (event) {
        $('.js-modalContact').addClass('active');
        $('body').css('overflow', 'hidden');
    }, false);
    $('.js-modalContactCls').click(function(){
        $('.js-modalContact').removeClass('active');
        $('body').css('overflow', '');
    });
    /*wpcf7 thankyou*/

    /*main modal tech slider*/
    $(document).ready(function () {
        $('.js-mainTechModalSlider').slick({
            arrows: true,
            dots: false,
            centerMode: false,
            slidesToShow: 1,
            prevArrow: '<button type="button" class="arrow prev-arrow" aria-label="Précédent"><svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M21 12L3 12" stroke="white" stroke-width="1.5" stroke-linecap="round"/> <path d="M9 18L3 12L9 6" stroke="white" stroke-width="1.5"/> </svg></button>',
            nextArrow: '<button type="button" class="arrow next-arrow" aria-label="Suivant"><svg aria-hidden="true" focusable="false" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3 12L21 12" stroke="white" stroke-width="1.5" stroke-linecap="round"/> <path d="M15 18L21 12L15 6" stroke="white" stroke-width="1.5" stroke-linecap="square"/> </svg></button>',
            appendArrows: $('.js-mainTechsSliderArrows')
        });
    });
    /*main modal tech slider*/

    /*modals*/
    $('.js-contMapBtn').click(function(){
        $('.js-mainMapModal').addClass('active');
    })
    $('.js-mainMapModalCls').click(function(){
        $('.js-mainMapModal').removeClass('active');
    })

    $('.js-mainTechsBl').click(function(){
        $('.js-mainTechModalSlider').slick('slickGoTo', $(this).data('key'), true);
        $('.js-mainTechModal').addClass('active');
    })
    $('.js-mainTechModalCls').click(function(){
        $('.js-mainTechModal').removeClass('active');
    })
    /*modals*/

    /*page-cons faq*/
    $('.js-pageConsFaqCat').click(function(){
        var id = $(this).data('id');
        if (id === 'all') {
            $('.js-pageConsFaqItem').slideDown();
        } else if ($('.js-pageConsFaqCat.active').data('id') === 'all') {
            $('.js-pageConsFaqItem:not([data-id="'+id+'"])').slideUp();
            $('.js-pageConsFaqItem:not([data-id="'+id+'"])').removeClass('opened');
        } else {
            $('.js-pageConsFaqItem').slideUp();
            $('.js-pageConsFaqItem').removeClass('opened');
            $('.js-pageConsFaqItem[data-id="'+id+'"]').slideDown();
            $('.js-pageConsFaqItem[data-id="'+id+'"]').addClass('opened');
        }
        $('.js-pageConsFaqCat').removeClass('active');
        $(this).addClass('active');

        $('.js-pageConsFaqBl').removeClass('active');
        $('.js-pageConsFaqBlWrap').removeClass('active');
        $('.js-pageConsFaqBlTxt').slideUp();
        $('.js-pageConsFaqItem[data-id="'+id+'"]').addClass('opened');
        $('.js-pageConsFaqItem.opened .js-pageConsFaqBlWrap').eq(0).addClass('active');
        $('.js-pageConsFaqItem.opened .js-pageConsFaqBlTxt').eq(0).slideDown();
    });

    $('.js-pageConsFaqBl').click(function(){
        var $wrap = $(this).closest('.js-pageConsFaqBlWrap');
        var willOpen = !$wrap.hasClass('active');
        $('.js-pageConsFaqBlWrap').removeClass('active');
        $('.js-pageConsFaqBlTxt').slideUp();
        if (willOpen) {
            $wrap.addClass('active');
            $(this).siblings('.js-pageConsFaqBlTxt').slideDown();
        }
    });
    /*page-cons faq*/

    /*tax_trait*/
    function taxTraitScrollSpy() {
        var $items = $('.js-taxTraitItem');
        if (!$items.length) return;

        var anchor = $(window).scrollTop() + $(window).height() * 0.45;
        var bestIdx = 0;
        var bestDist = Infinity;

        $items.each(function (i) {
            var center = $(this).offset().top + $(this).outerHeight() / 2;
            var dist = Math.abs(center - anchor);
            if (dist < bestDist) {
                bestDist = dist;
                bestIdx = i;
            }
        });

        $items.removeClass('active');
        $items.eq(bestIdx).addClass('active');
    }
    $(window).on('load scroll resize', taxTraitScrollSpy);
    /*tax_trait*/

    /*page-formations*/
    $('.js-pageFormationsCat').click(function(){
        var id = $(this).data('id');
        if (id === 'all') {
            $('.js-pageFormationsItem').fadeIn();
        } else if ($('.js-pageFormationsCat.active').data('id') === 'all') {
            $('.js-pageFormationsItem:not([data-id="'+id+'"])').fadeOut();
            $('.js-pageFormationsItem:not([data-id="'+id+'"])').removeClass('opened');
        } else {
            $('.js-pageFormationsItem').fadeOut();
            $('.js-pageFormationsItem').removeClass('opened');
            $('.js-pageFormationsItem[data-id="'+id+'"]').fadeIn();
            $('.js-pageFormationsItem[data-id="'+id+'"]').addClass('opened');
        }
        $('.js-pageFormationsCat').removeClass('active');
        $(this).addClass('active');
    });
    /*page-formations*/

    /*page cabinet*/
    var $pageCabinetTeamSlider = $('.js-pageCabinetTeamSlider');
    var pageCabinetTeamSliderOpts = {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        prevArrow: '<button type="button" class="arrow prev-arrow" aria-label="Précédent"><svg aria-hidden="true" focusable="false" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 1L1 7L7 13M1 7H17" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        nextArrow: '<button type="button" class="arrow next-arrow" aria-label="Suivant"><svg aria-hidden="true" focusable="false" width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 1L17 7L11 13M17 7H1" stroke="#ffffff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        appendArrows: $('.js-pageCabinetTeamArrows'),
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    };

    function pageCabinetTeamSliderToggle() {
        if (!$pageCabinetTeamSlider.length) return;
        var isInit = $pageCabinetTeamSlider.hasClass('slick-initialized');
        if (window.innerWidth < 992) {
            if (!isInit) $pageCabinetTeamSlider.slick(pageCabinetTeamSliderOpts);
        } else if (isInit) {
            $pageCabinetTeamSlider.slick('unslick');
        }
    }
    pageCabinetTeamSliderToggle();
    $(window).on('resize', pageCabinetTeamSliderToggle);

    $(document).ready(function() {
        var pagecabinetGalDir = 'left';
        if ($(window).width() > 991) {
            if ($('.js-pageCabinetGal').length > 0) {
                $('.js-pageCabinetGal').each(function (i) {
                    console.log(pagecabinetGalDir);
                    $(this).marquee({
                        startVisible: true,
                        duration: 25000,
                        gap: 0,
                        delayBeforeStart: 0,
                        direction: pagecabinetGalDir,
                        duplicated: true,
                        duplicateCount: 3,
                        pauseOnHover: true
                    });
                    if (pagecabinetGalDir === 'left') {
                        pagecabinetGalDir = 'right';
                    } else {
                        pagecabinetGalDir = 'left';
                    }
                });
            }
        }

        $('.js-pageCabinetGalSliderImg').click(function () {
            $('.js-pageCabinetGalModalSlider').slick('slickGoTo', $(this).data('img'), true);
            $('.js-pageCabinetGalModal').addClass('active');
        })

        $('.js-pageCabinetGalModalCls').click(function () {
            $('.js-pageCabinetGalModal').removeClass('active');
            setTimeout(function () {
                $('.js-pageCabinetGalModalImg').html('');
            }, 500)
        })


        $('.js-pageCabinetGalModalSlider').slick({
            arrows: true,
            centerMode: false,
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="arrow prev-arrow" aria-label="Précédent"><svg aria-hidden="true" focusable="false" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M14.5 7.03535H15V8.03535H14.5V7.53535V7.03535ZM0.5 8.03535C0.223858 8.03535 0 7.8115 0 7.53535C0 7.25921 0.223858 7.03535 0.5 7.03535V7.53535V8.03535ZM7.03474 0.5V0L8.03474 0V0.5L7.53474 0.5L7.03474 0.5ZM0.810138 7.90359C0.567717 8.03583 0.263996 7.9465 0.131761 7.70408C-0.000475883 7.46166 0.0888472 7.15794 0.331269 7.0257L0.570704 7.46465L0.810138 7.90359ZM8.0348 14.5V15H7.0348V14.5H7.5348H8.0348ZM14.5 7.53535V8.03535L0.570761 8.03535V7.53535V7.03535L14.5 7.03535V7.53535ZM0.570761 7.53535V8.03535H0.5V7.53535V7.03535H0.570761V7.53535ZM7.53474 0.5L8.03474 0.5C8.03474 1.46517 7.51122 2.40874 6.83424 3.23966C6.14729 4.08282 5.24358 4.88117 4.35846 5.56517C3.4704 6.25145 2.58482 6.83499 1.92269 7.24634C1.59115 7.45231 1.31451 7.6158 1.12013 7.72814C1.02292 7.78432 0.946214 7.82775 0.893425 7.85735C0.867028 7.87215 0.846606 7.88349 0.832584 7.89124C0.825573 7.89512 0.820162 7.89809 0.816403 7.90016C0.814524 7.90119 0.813058 7.90199 0.812011 7.90257C0.811488 7.90285 0.811069 7.90308 0.810758 7.90325C0.810601 7.90334 0.810446 7.90342 0.810368 7.90346C0.81024 7.90353 0.810138 7.90359 0.570704 7.46465C0.331269 7.0257 0.331221 7.02573 0.331199 7.02574C0.331226 7.02573 0.33123 7.02572 0.331285 7.02569C0.331397 7.02563 0.331613 7.02552 0.331933 7.02534C0.332573 7.02499 0.333631 7.02441 0.335099 7.0236C0.338035 7.02199 0.342612 7.01947 0.348778 7.01607C0.361109 7.00925 0.379791 6.99887 0.404401 6.98508C0.453625 6.95748 0.526535 6.91621 0.619744 6.86234C0.806212 6.75457 1.07364 6.59655 1.39498 6.39691C2.03861 5.99706 2.89404 5.43305 3.74698 4.77391C4.60288 4.11249 5.44017 3.36754 6.05898 2.60803C6.68775 1.83627 7.03474 1.11779 7.03474 0.5L7.53474 0.5ZM0.570761 7.53535C0.758092 7.07177 0.758235 7.07183 0.758404 7.0719C0.758495 7.07194 0.758692 7.07202 0.758875 7.07209C0.759243 7.07224 0.759716 7.07243 0.760294 7.07267C0.761451 7.07314 0.763028 7.07378 0.765019 7.07459C0.769002 7.07622 0.77464 7.07854 0.781881 7.08153C0.796362 7.08752 0.817256 7.09624 0.844136 7.10764C0.89789 7.13042 0.975623 7.16395 1.07391 7.20785C1.27042 7.29563 1.54951 7.42506 1.88372 7.59332C2.55089 7.92919 3.44389 8.42281 4.34008 9.05202C5.23369 9.67942 6.14794 10.4537 6.84276 11.3556C7.53813 12.2583 8.0348 13.3172 8.0348 14.5H7.5348H7.0348C7.0348 13.6076 6.66095 12.7582 6.05057 11.9659C5.43963 11.1729 4.61287 10.4654 3.76547 9.87045C2.92066 9.27731 2.07265 8.808 1.43406 8.48652C1.1154 8.32609 0.850417 8.20325 0.66608 8.12091C0.573947 8.07976 0.502062 8.04877 0.453804 8.02831C0.429679 8.01808 0.411468 8.01049 0.399595 8.00558C0.39366 8.00312 0.389309 8.00134 0.386597 8.00023C0.385241 7.99967 0.384295 7.99929 0.383764 7.99907C0.383499 7.99896 0.383338 7.9989 0.383282 7.99888C0.383254 7.99886 0.383291 7.99888 0.383277 7.99887C0.38334 7.9989 0.38343 7.99894 0.570761 7.53535Z" fill="white"/> </svg></button>',
            nextArrow: '<button type="button" class="arrow next-arrow" aria-label="Suivant"><svg aria-hidden="true" focusable="false" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0.5 7.03535H0L0 8.03535H0.5L0.5 7.53535L0.5 7.03535ZM14.5 8.03535C14.7761 8.03535 15 7.8115 15 7.53535C15 7.25921 14.7761 7.03535 14.5 7.03535V7.53535V8.03535ZM7.96526 0.5V0L6.96526 0V0.5L7.46526 0.5L7.96526 0.5ZM14.1899 7.90359C14.4323 8.03583 14.736 7.9465 14.8682 7.70408C15.0005 7.46166 14.9112 7.15794 14.6687 7.0257L14.4293 7.46465L14.1899 7.90359ZM6.9652 14.5V15H7.9652V14.5H7.4652H6.9652ZM0.5 7.53535L0.5 8.03535L14.4292 8.03535V7.53535V7.03535L0.5 7.03535L0.5 7.53535ZM14.4292 7.53535V8.03535H14.5V7.53535V7.03535H14.4292V7.53535ZM7.46526 0.5L6.96526 0.5C6.96526 1.46517 7.48878 2.40874 8.16576 3.23966C8.85271 4.08282 9.75642 4.88117 10.6415 5.56517C11.5296 6.25145 12.4152 6.83499 13.0773 7.24634C13.4088 7.45231 13.6855 7.6158 13.8799 7.72814C13.9771 7.78432 14.0538 7.82775 14.1066 7.85735C14.133 7.87215 14.1534 7.88349 14.1674 7.89124C14.1744 7.89512 14.1798 7.89809 14.1836 7.90016C14.1855 7.90119 14.1869 7.90199 14.188 7.90257C14.1885 7.90285 14.1889 7.90308 14.1892 7.90325C14.1894 7.90334 14.1896 7.90342 14.1896 7.90346C14.1898 7.90353 14.1899 7.90359 14.4293 7.46465C14.6687 7.0257 14.6688 7.02573 14.6688 7.02574C14.6688 7.02573 14.6688 7.02572 14.6687 7.02569C14.6686 7.02563 14.6684 7.02552 14.6681 7.02534C14.6674 7.02499 14.6664 7.02441 14.6649 7.0236C14.662 7.02199 14.6574 7.01947 14.6512 7.01607C14.6389 7.00925 14.6202 6.99887 14.5956 6.98508C14.5464 6.95748 14.4735 6.91621 14.3803 6.86234C14.1938 6.75457 13.9264 6.59655 13.605 6.39691C12.9614 5.99706 12.106 5.43305 11.253 4.77391C10.3971 4.11249 9.55983 3.36754 8.94102 2.60803C8.31225 1.83627 7.96526 1.11779 7.96526 0.5L7.46526 0.5ZM14.4292 7.53535C14.2419 7.07177 14.2418 7.07183 14.2416 7.0719C14.2415 7.07194 14.2413 7.07202 14.2411 7.07209C14.2408 7.07224 14.2403 7.07243 14.2397 7.07267C14.2385 7.07314 14.237 7.07378 14.235 7.07459C14.231 7.07622 14.2254 7.07854 14.2181 7.08153C14.2036 7.08752 14.1827 7.09624 14.1559 7.10764C14.1021 7.13042 14.0244 7.16395 13.9261 7.20785C13.7296 7.29563 13.4505 7.42506 13.1163 7.59332C12.4491 7.92919 11.5561 8.42281 10.6599 9.05202C9.76631 9.67942 8.85206 10.4537 8.15724 11.3556C7.46187 12.2583 6.9652 13.3172 6.9652 14.5H7.4652H7.9652C7.9652 13.6076 8.33905 12.7582 8.94943 11.9659C9.56037 11.1729 10.3871 10.4654 11.2345 9.87045C12.0793 9.27731 12.9274 8.808 13.5659 8.48652C13.8846 8.32609 14.1496 8.20325 14.3339 8.12091C14.4261 8.07976 14.4979 8.04877 14.5462 8.02831C14.5703 8.01808 14.5885 8.01049 14.6004 8.00558C14.6063 8.00312 14.6107 8.00134 14.6134 8.00023C14.6148 7.99967 14.6157 7.99929 14.6162 7.99907C14.6165 7.99896 14.6167 7.9989 14.6167 7.99888C14.6167 7.99886 14.6167 7.99888 14.6167 7.99887C14.6167 7.9989 14.6166 7.99894 14.4292 7.53535Z" fill="white"/> </svg></button>',
            appendArrows: $('.js-pageCabinetGalModalSliderArrows')
        });
    });
    /*page cabinet*/


    /*scroll sidebar
    $(window).on('load resize', function(){
        if ($('.js-pageTextSide').length > 0) {
            if ($(window).width() > 991) {
                var singleSidebarTop = $('.js-pageTextSide').offset().top;
                var singleSidebarRailTop = $('.js-pageTextSideRail').offset().top;
                var headerOffset = $('header').outerHeight();
                var windowTop = $(window).scrollTop() + headerOffset + 30;

                var singleSidebarH = $('.js-pageTextSide').outerHeight();
                var singleSidebarMenuH = $('.js-pageTextSideMenu').outerHeight();
                if (singleSidebarH > singleSidebarMenuH) {
                    $('.js-pageTextSideRail').height(singleSidebarH - singleSidebarMenuH);
                }
                var singleSidebarRailH = $('.js-pageTextSideRail').outerHeight();
                var singleSidebarRailBottom = singleSidebarRailTop + singleSidebarRailH;

                $(window).scroll(function(){
                    windowTop = $(window).scrollTop() + headerOffset + 30;
                    if (windowTop > singleSidebarTop && windowTop < singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', windowTop - singleSidebarTop)
                    } else if (windowTop > singleSidebarTop && windowTop >= singleSidebarRailBottom) {
                        $('.js-pageTextSideMenu').css('top', '100%')
                    } else if (windowTop <= singleSidebarTop) {
                        $('.js-pageTextSideMenu').css('top', '0')
                    }
                })
            } else {
                $('.js-pageTextSideRail').css('height', 'auto')
            }
        }
    })
    scroll sidebar*/

    /*toc active*/
    var $menu = $('.js-pageTextSideMenu');
    if ($menu.length === 0) return;

    var $links = $menu.find('.page-text-side-menu a[href^="#"]');
    if ($links.length === 0) return;

    var targets = [];
    var offset = 0;
    var activeIndex = -1;

    function calcOffset() {
        var $header = $('.js-header').length ? $('.js-header') : $('header');
        offset = ($header.outerHeight() || 0) + 40;
    }

    function buildTargets() {
        targets = [];
        $links.each(function () {
            var $link = $(this);
            var id = ($link.attr('href') || '').slice(1);
            if (!id) return;

            var el = document.getElementById(id);
            if (!el) return;

            // якір — це порожній .cont_anch (у нього transform), тому беремо сам заголовок
            var $el = $(el);
            var $hdr = $el.hasClass('cont_anch') ? $el.nextAll('h2, .h2').first() : $el;
            if ($hdr.length === 0) $hdr = $el;

            targets.push({ $link: $link, top: $hdr.offset().top });
        });

        targets.sort(function (a, b) { return a.top - b.top; });
    }

    function setActive(index) {
        if (index === activeIndex) return;
        activeIndex = index;

        $links.removeClass('active')
            .closest('.page-text-side-menu-item').removeClass('active');

        if (index < 0 || !targets[index]) return;

        targets[index].$link.addClass('active')
            .closest('.page-text-side-menu-item').addClass('active');
    }

    function update() {
        if (targets.length === 0) return;

        var scrollTop = $(window).scrollTop();
        var line = scrollTop + offset;
        var index = 0;

        for (var i = 0; i < targets.length; i++) {
            if (targets[i].top <= line) {
                index = i;
            } else {
                break;
            }
        }

        // доскролили до низу — підсвічуємо останній пункт
        if (scrollTop + $(window).height() >= $(document).height() - 2) {
            index = targets.length - 1;
        }

        setActive(index);
    }

    var ticking = false;
    function onScroll() {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
            update();
            ticking = false;
        });
    }

    function refresh() {
        calcOffset();
        buildTargets();
        activeIndex = -1;
        update();
    }

    $(document).ready(refresh);
    $(window).on('load resize', refresh);
    $(window).on('scroll', onScroll);

    // плавний скрол по кліку з урахуванням шапки
    $links.on('click', function (e) {
        var id = ($(this).attr('href') || '').slice(1);
        var el = document.getElementById(id);
        if (!el) return;

        var $hdr = $(el).hasClass('cont_anch') ? $(el).nextAll('h2, .h2').first() : $(el);
        if ($hdr.length === 0) $hdr = $(el);

        e.preventDefault();
        $('html, body').stop().animate({ scrollTop: $hdr.offset().top - offset + 10 }, 400);
    });
    /*toc active*/

    /*form file*/
    function formFileReset($block) {
        var $txt = $block.find('.js-formFileTxt');
        $block.find('input[type="file"]').val('');
        $block.removeClass('has-file');
        $txt.text($txt.data('placeholder'));
    }

    $(document).on('change', '.js-formFile input[type="file"]', function() {
        var $block = $(this).closest('.js-formFile');
        var $txt = $block.find('.js-formFileTxt');

        if (this.files && this.files.length > 0) {
            $txt.text(this.files[0].name);
            $block.addClass('has-file');
        } else {
            formFileReset($block);
        }
    });

    $(document).on('click', '.js-formFileCls', function(e) {
        e.preventDefault();
        e.stopPropagation();
        formFileReset($(this).closest('.js-formFile'));
    });

    document.addEventListener('wpcf7mailsent', function() {
        $('.js-formFile').each(function() {
            formFileReset($(this));
        });
    }, false);
    /*form file*/

    /*form file drag&drop*/
    $('.js-formFile').each(function() {
        var block = this;
        var input = $(block).find('input[type="file"]')[0];
        if (!input) return;

        ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(function(evName) {
            block.addEventListener(evName, function(e) {
                e.preventDefault();
                e.stopPropagation();
            }, false);
        });

        ['dragenter', 'dragover'].forEach(function(evName) {
            block.addEventListener(evName, function() {
                $(block).addClass('dragover');
            }, false);
        });

        ['dragleave', 'drop'].forEach(function(evName) {
            block.addEventListener(evName, function() {
                $(block).removeClass('dragover');
            }, false);
        });

        block.addEventListener('drop', function(e) {
            var files = e.dataTransfer && e.dataTransfer.files;
            if (!files || !files.length) return;

            var dt = new DataTransfer();
            dt.items.add(files[0]);
            input.files = dt.files;

            $(input).trigger('change');
        }, false);
    });
    /*form file drag&drop*/

    /*conditional fields*/
    function qmCondUpdate($form, animate) {
        $form.find('.js-condField').each(function() {
            var $field = $(this);
            var name = $field.data('cond-name');
            var showVal = String($field.data('cond-value'));
            var current = $form.find('input[name="' + name + '"]:checked').val();
            var show = (String(current) === showVal);

            if (animate) {
                if (show) { $field.stop(true, true).slideDown(200).addClass('active'); }
                else { $field.stop(true, true).slideUp(200).removeClass('active'); }
            } else {
                $field.toggle(show).toggleClass('active', show);
            }
        });
    }

    $('.js-condForm').each(function() {
        var $form = $(this);
        qmCondUpdate($form, false);
        $form.on('change', 'input[type="radio"]', function() {
            qmCondUpdate($form, true);
        });
    });

    document.addEventListener('wpcf7mailsent', function(e) {
        var $form = $(e.target).find('.js-condForm');
        if ($form.length) { qmCondUpdate($form, false); }
    }, false);
    /*conditional fields*/

    function baClientX(e) {
        if (e.clientX !== undefined) { return e.clientX; }
        if (e.originalEvent && e.originalEvent.clientX !== undefined) { return e.originalEvent.clientX; }
        return 0;
    }

    function baApply($cmp, pos) {
        pos = Math.max(0, Math.min(100, pos));
        $cmp[0].style.setProperty('--ba-pos', pos + '%');
        $cmp.find('.js-baHandle').attr('aria-valuenow', Math.round(pos));
        return pos;
    }

    function baPosFromX($cmp, clientX) {
        // getBoundingClientRect + clientX — обидва у viewport-координатах,
        // тому body { zoom: 0.8 } не збиває розрахунок
        var rect = $cmp[0].getBoundingClientRect();
        if (!rect.width) { return 50; }
        return ((clientX - rect.left) / rect.width) * 100;
    }

    $('.js-baCmp').each(function() {
        var $cmp = $(this);
        var cmp = this;
        var dragging = false;
        var current = 50;

        baApply($cmp, current);

        $cmp.on('pointerdown', function(e) {
            dragging = true;
            $cmp.addClass('dragging');
            if (cmp.setPointerCapture && e.pointerId !== undefined) {
                try { cmp.setPointerCapture(e.pointerId); } catch (err) {}
            }
            current = baApply($cmp, baPosFromX($cmp, baClientX(e)));
            e.preventDefault();
        });

        $cmp.on('pointermove', function(e) {
            if (!dragging) { return; }
            current = baApply($cmp, baPosFromX($cmp, baClientX(e)));
        });

        $cmp.on('pointerup pointercancel pointerleave', function(e) {
            if (!dragging) { return; }
            dragging = false;
            $cmp.removeClass('dragging');
            if (cmp.releasePointerCapture && e.pointerId !== undefined) {
                try { cmp.releasePointerCapture(e.pointerId); } catch (err) {}
            }
        });

        $cmp.on('dragstart', 'img', function(e) {
            e.preventDefault();
        });

        $cmp.find('.js-baHandle').on('keydown', function(e) {
            var step = (e.shiftKey) ? 10 : 2;
            if (e.key === 'ArrowLeft' || e.keyCode === 37) {
                current = baApply($cmp, current - step);
                e.preventDefault();
            } else if (e.key === 'ArrowRight' || e.keyCode === 39) {
                current = baApply($cmp, current + step);
                e.preventDefault();
            }
        });
    });


    /*page-text list slider*/
    $('.js-pageTextListSlider').each(function () {
        var $slider = $(this);
        var $wrap = $slider.closest('.page-text-list');

        function pad(n) {
            return (n < 10 ? '0' : '') + n;
        }

        $slider.on("init reInit beforeChange", function(event, slick, currentSlide, nextSlide) {
            var cnt = slick.options.slidesToScroll;
            var slideNum = (nextSlide === undefined) ? 1 : nextSlide + 1;
            $('.js-pageTextListCounter').html(
                '<span class="current">' + slideNum + '</span><span class="sep"> / </span><span class="all">' + (Math.ceil(slick.slideCount / cnt)) + '</span>'
            );
        });

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: false,
            speed: 500,
            appendArrows: $wrap.find('.js-pageTextListArrows'),
            prevArrow: '<button type="button" class="arrow prev-arrow" aria-label="Précédent"><svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 3L5 8L10 13" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            nextArrow: '<button type="button" class="arrow next-arrow" aria-label="Suivant"><svg aria-hidden="true" focusable="false" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 3L11 8L6 13" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
            responsive: [
                {
                    breakpoint: 1200,
                    settings: { slidesToShow: 2 }
                },
                {
                    breakpoint: 768,
                    settings: { slidesToShow: 1 }
                }
            ]
        });
    });
    /*page-text list slider*/

}( jQuery ) );
